module.exports = __webpack_public_path__ + "img/latte.cd6a58f8.png";